import { ListItemService } from 'application/services/list-item'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListItem = new ListItemService(api)